import React from 'react'
import { Form } from './Form'
import {Navigate, useNavigate} from 'react-router-dom';
import { useDispatch } from 'react-redux'
import {setUser} from '../store/slices/userSlices';
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import {getFirestore,doc,setDoc} from "firebase/firestore"

const Registr = () => {
const dispatch = useDispatch();
let navigate = useNavigate();


    const handleRegistr = (email,password,name) =>
{
    const auth = getAuth();
    const db = getFirestore();
    createUserWithEmailAndPassword(auth,email,password,name)
        .then(({user})=>{
            dispatch(setUser({
                email: user.email,
                id: user.uid,
                token: user.accessToken,
                name: user.name,
            }));
    
                try {
                  const ref = doc(db, "userinfo", user.uid)
                  setDoc(doc(db, "userinfo", user.uid), {
                    name: {name},
                    money: 100,
                    count: 0,
                    level: 1,
                    levelPrice: 500,
                  });
          
                } catch (e) {
                  console.error("Error adding document: ", e);
                }
            
            navigate('/game');
        })
        .catch()

}  
return (
    <div>
        <Form
            title="Регистрация"
            handleClick={handleRegistr}
        />
    </div>
  )
}

export {Registr}